<template>
  <!--begin::Product Internal Listing-->
  <v-container fluid>
    <v-row>
      <v-col md="3" v-if="false">
        <v-autocomplete
          v-model.trim="filter_status"
          :items="statusList"
          dense
          flat
          filled
          label="Visit Status"
          item-color="cyan"
          color="cyan"
          solo
          :disabled="pageLoading"
          :loading="pageLoading"
          item-value="status"
          item-text="text"
          class="filter-select"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title
                v-html="'No Status(s) Found.'"
              ></v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <v-list-item-action class="ma-0">
              <v-chip
                style="height: 10px; width: 10px; padding: 0"
                :color="item.color"
              >
              </v-chip>
            </v-list-item-action>
            <v-list-item-content class="py-0">
              <v-list-item-title
                class="text-capitalize font-weight-500 font-size-16"
              >
                <template v-if="item.value == 'all'"
                  >{{ item.text }} ({{ item.all_ticket_visits }})</template
                >
                <template v-else
                  >{{ item.text }} ({{
                    item.ticket_visit_status_count
                  }})</template
                >
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-action class="mr-0">
              <v-chip
                style="height: 16px; width: 16px; padding: 0"
                :color="item.color"
              >
              </v-chip>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="text-capitalize font-weight-500 font-size-16"
                >{{ item.text }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action
              class="align-self-center common-listing-row:nth-child"
            >
              <v-list-item-subtitle
                class="text-lowercase font-weight-500 font-size-14"
              >
                <template v-if="item.value == 'all'">{{
                  item.all_ticket_visits
                }}</template>
                <template v-else>{{
                  item.ticket_visit_status_count
                }}</template></v-list-item-subtitle
              >
            </v-list-item-action>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="3" v-if="type != 'property' && type != 'ticket'">
        <v-autocomplete
          class="ml-1"
          hide-details
          clearable
          v-model.trim="filter.property"
          :items="all_property"
          dense
          flat
          filled
          placeholder="Site Location"
          v-on:click:clear="clearFilter('property')"
          item-color="cyan"
          color="cyan"
          solo
          item-text="barcode"
          item-value="id"
          v-on:change="get_all_visits()"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title
                v-html="'No Site Location(s) Found.'"
              ></v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-icon class="mr-3">
              <v-icon>mdi-home-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-ellipsis max-width-400px">
              <v-list-item-title
                class="text-capitalize font-weight-500 font-size-16"
                >{{ item.barcode }} (
                <template v-if="item.unit_no"> {{ item.unit_no }},</template>
                <template v-if="item.street_1"> {{ item.street_1 }},</template>
                <template v-if="item.street_2"> {{ item.street_2 }},</template>
                <template v-if="item.zip_code">{{ item.street_2 }}</template
                >)
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="3">
        <v-menu
          v-if="false"
          v-model="datePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              filled
              flat
              placeholder="Dates Range"
              hide-details
              solo
              :disabled="dataLoading"
              :loading="dataLoading"
              v-on:click:clear="clearFilter('dates')"
              clearable
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              :value="formattedDate"
              class="mr-2"
              color="cyan"
            ></v-text-field>
          </template>
          <v-date-picker
            color="cyan"
            range
            :disabled="dataLoading"
            :loading="dataLoading"
            v-on:change="get_all_visits"
            v-model="dates"
          ></v-date-picker>
        </v-menu>
        <DateRangePicker
          placeholder="Data Range"
          v-model="dates"
          v-on:update:model-value="get_all_visits()"
          v-on:click:clear="clearFilter('dates')"
        ></DateRangePicker>
      </v-col>
      <v-col md="2">
        <v-autocomplete
          v-model="filter.job"
          dense
          clearable
          color="cyan"
          filled
          flat
          id="job-type"
          :items="ticketTypes"
          :disabled="dataLoading"
          :loading="dataLoading"
          solo
          placeholder="Job Type"
          v-on:click:clear="clearFilter('job_type')"
          item-color="cyan"
          item-text="value"
          item-value="id"
          hide-details
          return-object
          v-on:change="get_all_visits()"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  v-html="'No Job Type Found.'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:item="{ item }">
            <v-chip
              style="height: 16px; width: 16px; padding: 0; border-radius: 50%"
              :color="item?.color"
            >
            </v-chip>

            <v-list-item-content class="text-ellipsis max-width-400px">
              <v-list-item-title
                class="text-capitalize font-weight-500 font-size-16"
                >{{ item?.value }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col md="4" class="pl-0 d-flex">
        <v-text-field
          v-model.trim="filter.search"
          v-on:click:clear="clearFilter('search')"
          clearable
          dense
          filled
          flat
          placeholder="Search"
          hide-details
          solo
          :disabled="dataLoading"
          :loading="dataLoading"
          color="cyan"
          @keydown.enter="get_all_visits"
          @keydown.tab="get_all_visits"
        ></v-text-field>

        <v-btn
          depressed
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          tile
          :disabled="dataLoading"
          :loading="dataLoading"
          v-on:click="get_all_visits"
          style="height: 31px !important"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn
          depressed
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          tile
          :disabled="dataLoading"
          :loading="dataLoading"
          v-on:click="get_all_visits"
          style="height: 31px !important"
        >
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-btn
          v-if="this.type == 'ticket'"
          depressed
          :disabled="dataLoading"
          class="mx-2 custom-bold-button"
          v-on:click="exportQuotationVisits"
          color="cyan white--text"
        >
          <v-icon dark left>mdi-database-export</v-icon> Export
        </v-btn>

        <v-tooltip bottom content-class="custom-bottom-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="type == 'engineer'"
              v-bind="attrs"
              v-on="on"
              class="mx-2 custom-btn-color white--text"
              tile
              depressed
              :disabled="dataLoading"
              :loading="dataLoading"
              v-on:click="typeConfirmDialog = true"
            >
              <v-icon>mdi-plus</v-icon>
              Create Visit
            </v-btn>
          </template>
          <span>Create Visit</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <ListingTable
      :column-count="columnCount"
      :data-loading="dataLoading"
      :row-data="dataRows"
    >
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">Visit #</th>
            <th class="simple-table-th">Related #</th>
            <th class="simple-table-th">Title</th>
            <th class="simple-table-th" v-if="type == 'engineer'">Customer</th>
            <th class="simple-table-th" v-if="type == 'engineer'">
              Customer Info
            </th>
            <th
              class="simple-table-th"
              v-if="type != 'property' && type != 'ticket'"
            >
              Site Location
            </th>
            <th class="simple-table-th">Appointment Date</th>
            <th class="simple-table-th" v-if="false">Rating</th>
            <th class="simple-table-th">Status</th>
            <th class="simple-table-th">Job Type</th>
            <th class="simple-table-th">Assign To</th>
            <th class="simple-table-th">Total Hours Spent</th>
            <th class="simple-table-th">Action</th>
            <!--   <th class="simple-table-th">Created Time</th> -->
          </tr>
        </thead>
      </template>
      <template v-slot:tbody>
        <tbody class="custom-border-bottom custom-border-top">
          <template v-if="dataRows?.length">
            <template v-for="(row, index) in dataRows">
              <v-hover :key="index" v-slot="{ hover }">
                <tr
                  :class="
                    type == 'ticket'
                      ? 'visit-internal-listing-row'
                      : 'alternate-listing-row'
                  "
                  :key="index"
                >
                  <td>
                    <div class="d-flex align-center">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <Barcode
                          v-if="row.trip_barcode"
                          small
                          :barcode="row?.trip_barcode"
                          :id="row?.visit_id"
                          :route="'visit.detail'"
                        ></Barcode>
                      </p>
                      <template v-if="row?.night_job == 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="ml-1" style="font-size: 16px;">
                              <v-icon color="blue darken-4" small>mdi-moon-waning-crescent</v-icon>
                            </span>
                          </template>
                          <span> Night Job</span>
                        </v-tooltip>
                      </template>
                    </div>
                    <div>
                      <v-chip
                        small
                        class="font-weight-600 custom-blue-border text-uppercase justify-center my-1 font-10"
                        color="black"
                        label
                        outlined
                      >
                        {{ row.ticket_job_type_text }}
                      </v-chip>
                    </div>
                  </td>
                  <td>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <template
                        v-if="
                          row?.quotation_barcode ||
                          row?.preventive_barcode ||
                          row?.enquiries_barcode ||
                          row?.contract_barcode
                        "
                      >
                        <!--  <div class="my-0">
                            <v-chip
                              v-if="
                                row.ticket_job_type == 2 && row.preventive_barcode
                              "
                              small
                              class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10 mr-1"
                              color="red"
                              label
                              outlined
                              v-on:click.prevent.stop="
                                routeToDetailLink(
                                  row.preventive_id,
                                  'admin.preventive-maintanance.detail'
                                )
                              "
                            >
                              {{ row.preventive_barcode }}
                            </v-chip>
                          </div> -->
                        <div class="my-0">
                          <v-chip
                            small
                            v-if="row.quotation_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="cyan"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.quotation_id,
                                'admin.quotation.detail'
                              )
                            "
                          >
                            {{ row.quotation_barcode }}
                          </v-chip>
                        </div>
                        <div class="mt-0 mb-1">
                          <v-chip
                            small
                            v-if="row.contract_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="red"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.contract_id,
                                'admin.contract.detail'
                              )
                            "
                          >
                            {{ row.contract_barcode }}
                          </v-chip>
                        </div>
                        <div class="my-0">
                          <v-chip
                            small
                            v-if="row.enquiries_barcode"
                            class="text-white p-3 cursor-pointer mt-1"
                            color="orange"
                            label
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.enquiries_id,
                                'admin.enquiry.detail'
                              )
                            "
                          >
                            {{ row.enquiries_barcode }}
                          </v-chip>
                        </div>
                      </template>
                      <template v-else> --</template>
                    </p>
                  </td>
                  <td>
                    <div class="m-0 custom-nowrap-ellipsis-three-line d-flex">
                      <template v-if="row?.visit_title">
                        <div class="my-auto ml-1">
                          <read-more
                            class="custom-read-more font-size-16 pb-1"
                            more-str="read more"
                            :text="row?.visit_title || '<em>No Title</em>'"
                            link="#"
                            less-str="read less"
                            :max-chars="35"
                          >
                          </read-more>
                        </div>
                      </template>
                      <em class="text-muted" v-else> no title </em>
                    </div>
                  </td>
                  <td v-if="type == 'engineer'">
                    <div class="m-0 custom-nowrap-ellipsis-three-line">
                      <p class="m-0 custom-nowrap-ellipsis-three-line">
                        <b>Customer #: </b>
                        <template v-if="row && row.customer_company_barcode"
                          ><span class="font-weight-700">{{
                            row.customer_company_barcode
                          }}</span></template
                        >
                        <template v-else
                          ><em class="text--secondary">No barcode</em></template
                        >
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Display Name: </b>
                        <template v-if="row && row.customer_company_name">{{
                          row.customer_company_name
                        }}</template>
                        <template v-else
                          ><em class="text--secondary"
                            >No Display Name</em
                          ></template
                        >
                      </p>
                    </div>
                  </td>
                  <td v-if="type == 'engineer'">
                    <div class="m-0 custom-nowrap-ellipsis">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b><v-icon small>mdi-email</v-icon>: </b>
                        <template v-if="row && row.company_email">{{
                          row.company_email
                        }}</template>
                        <template v-else
                          ><em class="text--secondary">No Email</em></template
                        >
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b><v-icon small>mdi-phone</v-icon>: </b>
                        <template v-if="row && row.company_number">{{
                          row.company_number
                        }}</template>
                        <template v-else
                          ><em class="text--secondary">No Phone</em></template
                        >
                      </p>
                    </div>
                  </td>
                  <td v-if="type != 'property' && type != 'ticket'">
                    <template>
                      <div class="custom-flex-d" v-if="row.property_name">
                        <b>
                          <v-icon
                            style="font-size: 18px; margin-top: -3px"
                            class="cmt-2"
                          >
                            mdi-home-map-marker
                          </v-icon>
                        </b>
                        <span>{{ row.property_name }}<br /></span>
                      </div>
                      <div v-else>
                        <em class="text-muted">
                          <v-icon
                            style="font-size: 18px; margin-top: -3px"
                            class="cmt-2"
                          >
                            mdi-home-map-marker
                          </v-icon>
                          no Site Name</em
                        >
                      </div>
                    </template>

                    <template>
                      <div
                        class="custom-flex-d custom-nowrap-ellipsis-three-line"
                      >
                        <b>
                          <v-icon
                            style="font-size: 18px; margin-top: -3px"
                            class="cmt-2"
                          >
                            mdi-map-marker
                          </v-icon>
                        </b>
                        <span class="custom-nowrap-ellipsis-three-line">
                          <template v-if="row?.property_unit_no"
                            >{{ row.property_unit_no }},</template
                          >
                          <template v-if="row?.property_street_1"
                            >{{ row.property_street_1 }},</template
                          >
                          {{ row.property_street_2 }}
                          <!-- <br /> -->
                          {{ row.property_country }}
                          <template
                            v-if="
                              row?.property_zip_code &&
                              row.property_zip_code != '000000'
                            "
                          >
                            {{ row?.property_zip_code }}
                          </template>
                        </span>
                      </div>
                    </template>

                    <!-- <div class="m-0 custom-nowrap-ellipsis d-flex">
                      <template v-if="row?.property_address">
                        <div class="my-auto ml-1">
                          <read-more
                            class="custom-read-more font-size-16 pb-1"
                            more-str="read more"
                            :text="row?.property_address || '<em>No Title</em>'"
                            link="#"
                            less-str="read less"
                            :max-chars="35"
                          >
                          </read-more>
                        </div>
                      </template>
                      <em class="text-muted" v-else> no site location </em>
                    </div> -->
                  </td>
                  <td>
                    <div class="visit-date-info">
                      <p class="m-0">
                        <strong>Start:</strong>
                        {{ formatDate(row?.visit_started_at) }}
                        ({{ getDay(row?.visit_started_at) }})
                        {{ formatDateTimeStart(row?.visit_started_at) }}
                      </p>

                      <p class="m-0">
                        <strong>End:</strong>
                        {{ formatDate(row?.visit_finished_at) }}
                        ({{ getDay(row?.visit_finished_at) }})
                        {{ formatDateTimeStart(row?.visit_finished_at) }}
                      </p>
                    </div>
                  </td>
                  <td v-if="false">
                    <div class="custom-nowrap-ellipsis">
                      <template v-if="row.visit_status == 4">
                        <template v-if="row?.rating_status == 3">
                          <v-rating
                            v-if="row.visit_rating_type == 'star'"
                            readonly
                            dense
                            v-model.trim="row.visit_rating_value"
                            background-color="orange lighten-3"
                            color="orange"
                          ></v-rating>
                          <v-rating
                            color=""
                            v-model.trim="row.visit_rating_value"
                            readonly
                            v-if="
                              row.visit_status == 4 &&
                              row.visit_rating_type == 'number'
                            "
                          >
                            <template v-slot:item="props">
                              <v-avatar
                                class="mx-1"
                                style="border: 2px solid orange"
                                :color="
                                  props.isFilled ? 'orange text-white' : ''
                                "
                                size="25"
                              >
                                <span class="text-h6">{{
                                  props.index + 1
                                }}</span>
                              </v-avatar>
                            </template>
                          </v-rating>
                        </template>
                        <template v-else>
                          <v-chip
                            label
                            :color="getReviewStatusColor(row?.rating_status)"
                            text-color="white"
                            small
                            class="ml-1"
                          >
                            {{ row?.rating_status_text }}
                          </v-chip>
                        </template>
                      </template>
                      <template v-else>
                        <em class="text-muted"> no rating</em>
                      </template>
                    </div>
                  </td>

                  <td>
                    <div class="custom-nowrap-ellipsis">
                      <div>
                        <v-chip
                          class="mx-2 mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                          :color="getStatusColor(row.visit_status)"
                          label
                          small
                          text-color="white"
                        >
                          {{ row.visit_status_text }}
                        </v-chip>
                      </div>
                      <template v-if="row.follow_ups_data == 1">
                        <div class="">
                          <v-chip
                            small
                            label
                            outlined
                            class="mx-2 d-inline justify-center font-10"
                            text-color=""
                            color="green"
                          >
                            Follow Up Open
                          </v-chip>
                        </div>
                      </template>
                      <template v-if="row.follow_ups_data == 2">
                        <div class="my-1">
                          <v-chip
                            small
                            label
                            outlined
                            class="mx-2 d-inline justify-center font-10"
                            text-color=""
                            color="red"
                          >
                            Follow Up Closed
                          </v-chip>
                        </div>
                      </template>
                      <CustomStatus
                        v-if="false"
                        small
                        :status="row?.visit_status"
                        endpoint="visit/status"
                      ></CustomStatus>
                    </div>
                  </td>
                  <td>
                    <v-chip
                      v-if="row?.ticket_type && row?.ticket_type?.length > 0"
                      label
                      color="green"
                      class="p-2 ml-2"
                      text-color="white"
                      small
                    >
                      {{
                        String(row?.ticket_type || "")
                          .replace(/_/g, " ")
                          .replace(/^./, (c) => c.toUpperCase())
                      }}
                    </v-chip>
                    <v-chip
                      v-if="row?.ticket_type && row?.ticket_type?.length == 0"
                      label
                      color="red"
                      class="p-3 mr-5"
                      text-color="white"
                      small
                      >No Job Type</v-chip
                    >
                  </td>
                  <td>
                    <div class="custom-nowrap-ellipsis-three-line">
                      <p
                        class="m-0 max-content-width text-truncate font-weight-700 text-capitalize"
                        :class="{
                          'text--secondary': lodash.isEmpty(
                            row.visit_engineers
                          ),
                        }"
                      >
                        {{ engineerDisplayText(row.visit_engineers) }}
                      </p>
                    </div>
                    <div>
                      <v-chip
                        v-if="
                          row?.visit_engineers &&
                          row.visit_engineers?.length > 0
                        "
                        label
                        color="orange"
                        class="p-3 mr-5"
                        text-color="white"
                        small
                        >Assign</v-chip
                      >
                      <v-chip
                        v-if="
                          row?.visit_engineers &&
                          row?.visit_engineers?.length == 0
                        "
                        label
                        color="#24326d"
                        class="p-3 mr-5"
                        text-color="white"
                        small
                        >Unassign</v-chip
                      >
                    </div>
                  </td>
                  <td class="simple-table-td" v-if="false">
                    <TableActivity :data="row">
                      <template v-slot:date_time>
                        <template v-if="getDateCountAll(row?.added_at)">{{
                          row?.created_at
                        }}</template>
                        <template v-else>{{
                          formatDateTime(row?.added_at)
                        }}</template>
                      </template>
                      <template v-slot:format_date_time>
                        {{ formatDate(row?.added_at) }}
                        {{ formatTime(row?.added_at) }}
                      </template>
                    </TableActivity>
                  </td>
                  <td>
                    <b>
                      <span
                        v-if="row.total_time"
                        style="font-size: 14px; font-weight: 600"
                      >
                        {{ row.total_time }}
                      </span>
                      <em class="text-muted" v-else> no Hours Spent</em>
                    </b>
                  </td>
                  <td>
                    <v-icon
                      :disabled="row.visit_status == 1 ? false : true"
                      size="30"
                      color="red lighten-1"
                      v-on:click.stop.prevent="deleteTicket(row)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </v-hover>
            </template>
          </template>
          <tr v-else>
            <td :colspan="columnCount">
              <p
                class="m-0 row-not-found text-center font-weight-500 font-size-16"
              >
                <img
                  :src="$assetURL('media/error/empty.png')"
                  class="row-not-found-image"
                />
                Uhh... There are no visit at the moment.
              </p>
            </td>
          </tr>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      :dataLoading="dataLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
    ></ListingFooter>
    <Dialog :commonDialog="typeConfirmDialog">
      <template v-slot:title>Confirmation</template>
      <template v-slot:body>
        <v-container fluid class="py-0">
          <v-row>
            <v-col lg="12">
              <RadioInputCustom
                v-model="jobType"
                row
                color="blue darken-4"
                :items="[
                  {
                    label: 'Adhoc Job',
                    value: 'one-off',
                  },
                  {
                    label: `Recurring Job`,
                    value: 'recurring',
                  },
                ]"
              ></RadioInputCustom>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          v-on:click="pushToVisit()"
        >
          Continue
        </v-btn>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="typeConfirmDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
    <DeleteDialog :delete-dialog="deleteTicketDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-14 font-weight-500 delete-text text-center">
          Once you delete
          <span class="font-weight-700">{{ deleteTicketBarcode }}</span
          >, you won't be able to retrieve this later.<br />Are you sure you
          want to delete
          <span class="font-weight-700">{{ deleteTicketBarcode }}</span>
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteVisitLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteTicketDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteVisitLoading"
          :loading="deleteVisitLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteVisitConfirm()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>
  </v-container>
  <!--end::Product Internal Listing-->
</template>

<script>
import { QUERY, PUT } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
/*   import moment from "moment"; */
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
import RadioInputCustom from "@/view/components/RadioInputCustom.vue";
import Dialog from "@/view/pages/partials/Dialog";
import moment from "moment-timezone";
import DeleteDialog from "@/view/pages/partials/Delete";

import JwtService from "@/core/services/jwt.service";
export default {
  mixins: [CommonMixin, FileManagerMixin, ValidationMixin],
  name: "equipment-internal-list",
  data() {
    return {
      ticket_job_type: null,
      deleteVisitId: null,
      parent: 0,
      dates: [],
      statusList: [],
      jobTypeList: [],
      warrantyDurationTypes: [
        { text: "Month(s)", value: "month" },
        { text: "Year(s)", value: "year" },
      ],
      dataRows: [],
      ticketTypes: [],
      totalPages: 0,
      paginationPageSize: 15,
      currentPage: 1,
      totalRows: 0,
      all_property: [],
      rowsOffset: 0,
      dataLoading: true,
      manage_brand: false,
      manage_location: false,
      form_loading: false,
      image_loading: false,
      pageLoading: false,
      filter: {
        status: "all",
        search: null,
        property: null,
        customer: null,
        engineer: null,
        job: null,
      },
      timeoutLimit: 500,
      typeConfirmDialog: false,
      jobType: "one-off",
      deleteTicketId: null,
      deleteTicketDialog: false,
      deleteVisitLoading: false,
      deleteTicketBarcode: null,
    };
  },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {
        return new Object();
      },
    },
    type: {
      type: String,
      required: true,
      default: "customer",
    },
    contractId: {
      type: Number,
      default: 0,
    },
    visitCount: {
      type: Number,
      default: 0,
    },
    hideAction: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: 0,
    },
    propertyId: {
      type: Number,
      default: 0,
    },
    engineerId: {
      type: Number,
      default: 0,
    },
    invoiceId: {
      type: Number,
      default: 0,
    },
    quotationId: {
      type: Number,
      default: 0,
    },
    enquiryId: {
      type: Number,
      default: 0,
    },
    ticketId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        if (this.lodash.isEmpty(param) === false) {
          this.parent = this.lodash.toSafeInteger(param.id);
          if (this.parent > 0) {
            this.get_all_visits();
          }
        }
      },
    },
  },
  components: {
    CustomStatus,
    TableActivity,
    Dialog,
    RadioInputCustom,
    ListingFooter,
    ListingTable,
    Barcode,
    DateRangePicker,
    DeleteDialog,
  },
  methods: {
    getDay(date) {
      if (date) {
        return moment(date).format("dddd");
      }
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    pushToVisit() {
      const _this = this;
      _this.$router.push(
        _this.getDefaultRoute("job.create", {
          query: {
            technician: this.lodash.toString(_this.engineerId),
            type: this.jobType,
          },
        })
      );
    },
    exportQuotationVisits() {
      const _this = this;
      if (this.filter?.property > 0) {
        this.propertyId = this.filter?.property;
      }
      if (this.filter?.customer > 0) {
        this.customerId = this.filter?.customer;
      }
      if (this.filter?.engineer > 0) {
        this.engineerId = this.filter?.engineer;
      }

      let filter = {
        status: "all",
        search: _this.filter.search || undefined,
        customer:
          this.customerId && this.customerId != null ? this.customerId : 0,
        property:
          this.propertyId && this.propertyId != null ? this.propertyId : 0,
        engineer:
          this.engineerId && this.engineerId != null ? this.engineerId : 0,
        invoice: this.invoiceId && this.invoiceId != null ? this.invoiceId : 0,
        quotation:
          this.quotationId && this.quotationId != null ? this.quotationId : 0,
        contract: this.contractId ? this.contractId : null,
        enquiry: this.enquiryId && this.enquiryId != null ? this.enquiryId : 0,
        ticket: this.ticketId && this.ticketId != null ? this.ticketId : 0,
        dates: this.dates ? this.dates : [],
      };
      let downloadURL = process.env.VUE_APP_API_URL + "recurring-visits/export";
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);

      this.lodash.map(filter, function (row, index) {
        if (index === "dates" && row) {
          if (row[0]) downloadURL.searchParams.append("dates[0]", row[0]);
          if (row[1]) downloadURL.searchParams.append("dates[1]", row[1]);
        } else {
          downloadURL.searchParams.append(index, row);
        }
      });

      window.open(downloadURL, "_blank");
    },

    detailWarrnty(param) {
      this.$router.push(
        this.getDefaultRoute("warranty.detail", {
          params: {
            id: param,
          },
        })
      );
    },
    detailvisit(param) {
      this.$router.push(
        this.getDefaultRoute("visit.detail", {
          params: {
            id: param,
          },
        })
      );
    },
    routeToDetailLink(id, type) {
      if (this.contractId > 0 && type == "admin.contract.detail") {
        return false;
      }
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    getReviewStatusColor(rating_status) {
      switch (rating_status) {
        case 1:
          return "cyan";
        case 2:
          return "orange";
        case 3:
          return "green";
        case 4:
          return "red";
        case 5:
          return "orange";
      }
    },
    get_formatted_property(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }
      if (row.zip_code) {
        tempArr.push(row.zip_code);
      }
      if (row.country_name) {
        tempArr.push(row.country_name);
      }
      return tempArr.join(", ");
    },

    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
        case "property":
          _this.filter.property = null;
          _this.propertyId = 0;
          break;
        case "customer":
          _this.filter.customer = null;
          break;
        case "job_type":
          _this.filter.job = null;
          break;
      }
      _this.get_all_visits();
    },
    engineerDisplayText(param) {
      const _this = this;
      let display_name = new Array();
      if (
        _this.lodash.isEmpty(param) === false &&
        _this.lodash.isArray(param)
      ) {
        display_name.push(param[0].display_name);
        if (param.length - 1) {
          const message = ` +${param.length - 1} more...`;
          display_name.push(message);
        }
      }
      if (_this.lodash.isEmpty(display_name)) {
        return "Not assigned.";
      } else {
        return display_name.join(", ");
      }
    },
    get_all_visits() {
      const _this = this;
      if (this.filter?.property > 0) {
        this.propertyId = this.filter?.property;
      }
      if (this.filter?.customer > 0) {
        this.customerId = this.filter?.customer;
      }
      if (this.filter?.engineer > 0) {
        this.engineerId = this.filter?.engineer;
      }

      let filter = {
        status: "all",
        per_page: _this.paginationPageSize,
        current_page: _this.currentPage,
        job: _this.filter.job?.value || null,
        search: _this.filter.search || undefined,
        customer: this.customerId ? this.customerId : null,
        property:
          this.propertyId && this.propertyId != null ? this.propertyId : 0,
        engineer: this.engineerId ? this.engineerId : null,
        invoice: this.invoiceId ? this.invoiceId : null,
        quotation: this.quotationId ? this.quotationId : null,
        contract: this.contractId ? this.contractId : null,
        enquiry: this.enquiryId ? this.enquiryId : null,
        ticket: this.ticketId ? this.ticketId : null,
        dates: this.dates ? this.dates : [],
      };

      clearTimeout(_this.timeout);
      _this.dataRows = [];
      _this.dataLoading = true;
      _this.timeout = setTimeout(function () {
        _this.$store
          .dispatch(QUERY, {
            url: `internal/visits`,
            data: filter,
          })
          .then(({ data }) => {
            _this.dataRows = data.rows;
            _this.ticketTypes = data.ticket_types;
            _this.totalPages = Math.ceil(data.total_rows / data.per_page);
            _this.currentPage = data.current_page;
            _this.totalRows = data.total_rows;
            _this.rowsOffset = data.offset;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.dataLoading = false;
          });
      }, _this.timeoutLimit);
    },
    get_property() {
      this.$store
        .dispatch(QUERY, {
          url: `property/customer/${this.customerId}`,
          data: { search: this.search, status: "all" },
        })
        .then(({ data }) => {
          this.all_property = data.rows;
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    deleteTicket({ ticket_id, visit_barcode, visit_id, ticket_job_type }) {
      this.deleteTicketId = ticket_id;
      this.deleteVisitId = visit_id;
      this.ticket_job_type = ticket_job_type;
      this.deleteTicketDialog = true;
      this.deleteTicketBarcode = visit_barcode;
    },
    deleteVisitConfirm() {
      this.deleteVisitLoading = true;
      this.$store
        .dispatch(PUT, {
          url: `ticket-single/${this.deleteTicketId}`,
          data: {
            ticket_job_type: this.ticket_job_type,
            visit_id: this.deleteVisitId,
            visitCount: this.visitCount,
          },
        })
        .then((data) => {
          if (data?.data?.remaining_visit == 0 && this.hideAction) {
            this.$router.replace({
              name: "admin.recurring-job",
              query: { status: "all" },
            });
          }
          this.deleteTicketId = null;
          this.deleteTicketDialog = false;
          this.deleteTicketBarcode = null;
          this.get_all_visits();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteVisitLoading = false;
        });
    },
  },

  mounted() {
    const _this = this;
    // _this.get_options();
    PaginationEventBus.$on("update:pagination", (param) => {
      _this.currentPage = param;
      _this.get_all_visits();
    });
    _this.get_property();
    /*   _this.$nextTick(() => {
        _this.equipment.customer = _this.equipmentId;
      }); */
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 70);
    },
    columnCount() {
      let result = 9;
      return result;
    },
    showingFrom() {
      return this.lodash.isEmpty(this.dataRows) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.dataRows ? this.dataRows?.length : 0);
    },
  },
};
</script>
